import { ADMIN_ROLE, AGENT_ROLE } from '@/shared/constants';

export default (http, router, authService, userService) => {
  return {
    namespaced: true,
    state: {
      user: null,
      loading: false,
    },
    getters: {
      userIsAdmin(state) {
        return state.user && state.user.role === ADMIN_ROLE;
      },
      userIsAgent(state) {
        return state.user && state.user.role === AGENT_ROLE;
      },
    },
    mutations: {
      loading(state) {
        state.loading = true;
      },
      loginSuccess(state, user) {
        state.loading = false;
        state.user = user;
      },
      loginFailed(state, error) {
        state.loading = false;
      },
      logout(state) {
        state.user = null;
        delete http.defaults.headers.common.Authorization;
        localStorage.removeItem('jwt');
      },
    },
    actions: {
      async login(context, { email, password, sessionCode, answer }) {
        context.commit('loading');
        try {
          const jwt =
            'Bearer ' +
            (await authService.login(email, password, sessionCode, answer));
          http.defaults.headers.common.Authorization = jwt;
          localStorage.setItem('jwt', jwt);
          const user = await userService.getCurrentUser();
          context.commit('loginSuccess', user);
          await router.push({ name: 'home' });
        } catch (e) {
          context.commit('loginFailed', e);
          throw e.response.data;
        }
      },

      async logout(context) {
        context.commit('logout');
      },

      async recover(context) {
        console.info('try to recover session');
        try {
          const jwt = localStorage.getItem('jwt');
          if (jwt) {
            http.defaults.headers.common.Authorization = jwt;
          }
          const user = await userService.getCurrentUser();
          console.info('Session recovery success');
          context.commit('loginSuccess', user);
        } catch (e) {
          console.info('Failed to recover session');
          context.commit('logout');
        }
      },
    },
  };
};
